export const REDDY_MAIN_GROUP_LINK = 'https://lnk.reddy.team/invite/bQIsUh3jVMtkPDHvDcK~QVU6Ej4IGy1f';
export const REDDY_UFC_GROUP_LINK = 'https://lnk.reddy.team/invite/q6zX3Vd6J~ALxIZKu1jTWQaD~sLHV545';
